module.exports = __webpack_public_path__ + "assets/goole-lunar-x-prize-5818231888e7a37d41463a2dec4aeb65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/goole-lunar-x-prize.jpg
// module id = 513
// module chunks = 1